import { toast } from "react-hot-toast";
import {
  BsCheckCircleFill,
  BsInfoCircle,
  BsXCircleFill,
  BsXLg,
} from "react-icons/bs";
import { generateIcon } from "utils";

function success(text: string, duration = 3500) {
  return toast.custom(
    (t) => (
      <div
        style={{
          opacity: t.visible ? 1 : 0,
          transition: "opacity 100ms ease-in-out",
          maxWidth: "400px",
          padding: "15px",
        }}
        className="bg-white shadow-lg rounded-lg flex flex-row items-center gap-[20px]"
      >
        <span>{generateIcon(BsCheckCircleFill, "text-[22px] text-green")}</span>
        <p className="text-[16px] whitespace-break-spaces">{text}</p>
        <button type="button" onClick={() => toast.dismiss(t.id)}>
          {generateIcon(BsXLg)}
        </button>
      </div>
    ),
    { duration }
  );
}

function error(text?: string, duration = 8000) {
  return toast.custom(
    (t) => (
      <div
        style={{
          opacity: t.visible ? 1 : 0,
          transition: "opacity 100ms ease-in-out",
          maxWidth: "400px",
          padding: "15px",
        }}
        className="bg-white shadow-lg rounded-lg flex flex-row items-center gap-[20px]"
      >
        <span>{generateIcon(BsXCircleFill, "text-[22px] text-error")}</span>
        <p className="text-[16px] whitespace-break-spaces">{text}</p>
        <button type="button" onClick={() => toast.dismiss(t.id)}>
          {generateIcon(BsXLg)}
        </button>
      </div>
    ),
    { duration }
  );
}

function validationError(errorProp: string | string[], duration = 8000) {
  const getErrors = (): string[] => {
    if (typeof errorProp === "string") {
      return [errorProp];
    }
    return errorProp;
  };

  return toast.custom(
    (t) => (
      <div
        style={{
          opacity: t.visible ? 1 : 0,
          transition: "opacity 100ms ease-in-out",
          maxWidth: "400px",
          padding: "15px",
        }}
        className="bg-white shadow-lg rounded-lg flex flex-row items-center gap-[20px]"
      >
        <span>{generateIcon(BsXCircleFill, "text-[22px] text-error")}</span>
        <div className="flex flex-col gap-3">
          {getErrors().map((_error, idx) => (
            <p key={idx} className="text-[16px] whitespace-break-spaces">
              {_error}
            </p>
          ))}
        </div>
        <button type="button" onClick={() => toast.dismiss(t.id)}>
          {generateIcon(BsXLg)}
        </button>
      </div>
    ),
    { duration }
  );
}

function info(text: string | any, duration = 8000) {
  return toast.custom(
    (t) => (
      <div
        style={{
          opacity: t.visible ? 1 : 0,
          transition: "opacity 100ms ease-in-out",
          maxWidth: "400px",
          padding: "15px",
        }}
        className="bg-white shadow-lg rounded-lg flex flex-row items-center gap-[20px]"
      >
        <span>{generateIcon(BsInfoCircle, "text-[22px]")}</span>
        <p className="text-[16px] whitespace-break-spaces">{text}</p>
        <button onClick={() => toast.dismiss(t.id)} type="button">
          {generateIcon(BsXLg)}
        </button>
      </div>
    ),
    { duration }
  );
}

function promise<U>(
  apiCall: Promise<U>,
  successMessage: string,
  errorMessage: string,
  loadingText?: string,
  duration = 3500
) {
  return toast.promise(
    apiCall,
    {
      loading: loadingText || "Folyamatban...",
      success: successMessage,
      error: errorMessage,
    },
    { duration }
  );
}

export const toastMessage = {
  success,
  error,
  validationError,
  info,
  promise,
};
